// import payloadImg from "../assets/images/payload-capacity-banner.png";
// import comfortImg from "../assets/images/driver-comfort-banner.png";
// import safetyImg from "../assets/images/safety-systems-banner.png";
// import connectivityImg from "../assets/images/smart-connectivity-banner.png";

// const homeFeaturesData = [
//   {
//     id: "payload",
//     title: "Payload Capacity",
//     tabSubtitle:"Smart Performance",
//     tabTitle: "Engineered Precision",
//     imageSrc: payloadImg,
//     description:
//       "Engineered with a high-strength chassis and optimized load distribution, the LANDKING truck delivers exceptional payload capacity, allowing it to carry heavier loads with stability, efficiency, and confidence across demanding commercial operations."
//   },
//   {
//     id: "comfort",
//     title: "Driver Comfort",
//     tabSubtitle:"Tab Subtitle 2",
//     tabTitle: "Tab Title 2",
//     imageSrc: comfortImg,
//     description:
//       "An ergonomically designed cabin with intuitive controls, a modern infotainment system, and a driver-focused layout ensures maximum comfort, reduced fatigue, and a relaxed driving experience even during long working hours."
//   },
//   {
//     id: "safety",
//     title: "Safety Systems",
//     tabSubtitle:"Tab Subtitle 3",
//     tabTitle: "Tab Title 3",
//     imageSrc: safetyImg,
//     description:
//       "A high-visibility digital instrument cluster provides real-time safety alerts, system warnings, and critical vehicle status information, ensuring the driver stays informed, alert, and in full control at all times. Equipped with ABS+ASR feature and more ensures the driver and the business safety."
//   },
//   {
//     id: "connectivity",
//     title: "Smart Connectivity",
//     tabSubtitle:"Tab Subtitle 4",
//     tabTitle: "Tab Title 4",
//     imageSrc: connectivityImg,
//     description:
//       "An intuitive touchscreen infotainment system keeps the driver seamlessly connected with hands-free calling, multimedia control, and clear FM audio access delivering modern convenience, safety, and control at every drive."
//   }
// ];

// export default homeFeaturesData;


import payloadImg from "../assets/images/payload-capacity-banner.png";
import comfortImg from "../assets/images/driver-comfort-banner.png";
import safetyImg from "../assets/images/safety-systems-banner.png";
import connectivityImg from "../assets/images/smart-connectivity-banner.png";

const homeFeaturesData = [
  {
    id: "payload",
    titleKey: "common.homeFeatures.payload.title",
    // tabSubtitleKey: "common.homeFeatures.payload.tabSubtitle",
    // tabTitleKey: "common.homeFeatures.payload.tabTitle",
    imageSrc: payloadImg,
    descriptionKey: "common.homeFeatures.payload.description",
  },
  {
    id: "comfort",
    titleKey: "common.homeFeatures.comfort.title",
    // tabSubtitleKey: "common.homeFeatures.comfort.tabSubtitle",
    // tabTitleKey: "common.homeFeatures.comfort.tabTitle",
    imageSrc: comfortImg,
    descriptionKey: "common.homeFeatures.comfort.description",
  },
  {
    id: "safety",
    titleKey: "common.homeFeatures.safety.title",
    // tabSubtitleKey: "common.homeFeatures.safety.tabSubtitle",
    // tabTitleKey: "common.homeFeatures.safety.tabTitle",
    imageSrc: safetyImg,
    descriptionKey: "common.homeFeatures.safety.description",
  },
  {
    id: "connectivity",
    titleKey: "common.homeFeatures.connectivity.title",
    // tabSubtitleKey: "common.homeFeatures.connectivity.tabSubtitle",
    // tabTitleKey: "common.homeFeatures.connectivity.tabTitle",
    imageSrc: connectivityImg,
    descriptionKey: "common.homeFeatures.connectivity.description",
  }
];

export default homeFeaturesData;